"use client"

import { useEffect, useRef, useState } from "react"

/**
 * Reveals children with a GPU-only (opacity + transform) transition the first
 * time they scroll into view. Staggering is done by passing a `delay` (ms).
 * Honors prefers-reduced-motion via the .reveal rules in index.css.
 */
export default function Reveal({ children, delay = 0, className = "", as: Tag = "div", ...props }) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true)
      return
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          io.disconnect()
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...props}
    >
      {children}
    </Tag>
  )
}
